import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type Props = {
	popularity: number | undefined;
	intl: IntlShape;
};

function Popularity(props: Props) {
	const {
		popularity,
		intl: { formatMessage },
	} = props;

	const content = formatMessage(messages.popularity, { popularity });

	return isVisualRefreshEnabled() && fg('visual-refresh_drop_3') ? (
		<Flex alignItems="center" direction="row" xcss={styles.containerStyles}>
			{content}
		</Flex>
	) : (
		<Container>{content}</Container>
	);
}

const styles = cssMap({
	containerStyles: {
		flex: '1 1 auto',
		width: '100%',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		height: '40px',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});

export default injectIntl(Popularity);
